import "components/ShoppableImage/ShoppableImage"
import EmptyLayout from "layout/EmptyLayout"
import AppLayout from "layout/AppLayout"
import RouteWithLayout from "layout/RouteWithLayout"
import { observer } from "mobx-react"
import LoginHandPage from "pages/LoginHandPage"
import SalesPage from "pages/SalesPage"
import React from "react"
import { Link } from "react-router-dom"
import { Icon } from "semantic-ui-react"
import shop from "shop/shop"
import App from "theme/base/App"
import "./theme.scss"

const BASE = shop.config.BASE

shop.config.printCollectionPage = true
shop.config.usePDFExport = true
shop.config.login_wall = false

@observer
class CurrentCustomer extends React.Component {
  
  render() {
    
    const { session } = shop
    if ( !session.handId ) return null
    
    return <div className="CurrentCustomer relative">
      <Link to={"/login/accounts/"} className={"hide-child show-monkey"} key="01">
        
        <div className="absolute pa1 white child"><Icon name={"exchange"}/>{shop.session.customer.map_id}
          <span className="f6 white-80"> {translate( "wechseln" )}</span>
        </div>
        
        <div className={"pa1 white monkey"}>
          <Icon className={"white"} name="user"/>{shop.session.customer.map_id}
          <span className="f6 white-80"> {shop.session.customer.title}, {shop.session.customer.pcode} {shop.session.customer.city}</span>
        </div>
      
      </Link>
    </div>
  }
}


@observer
class AppLucht extends React.Component {
  
  render() {
    return <App
      before={<CurrentCustomer/>}
    >
      <RouteWithLayout layout={EmptyLayout} path={"/login/accounts"} component={LoginHandPage}/>
      <RouteWithLayout layout={AppLayout} path={"/collection/sale/"} component={SalesPage}/>
      <RouteWithLayout layout={AppLayout} path={"/collection/sales/"} component={SalesPage}/>
    </App>
  }
}

export default AppLucht



// WEBPACK FOOTER //
// ./src/theme/lucht-test/App.js